import { PanelLeftOpenIcon, PanelRightOpenIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const DashboardScheduleWeekExpandFab = ({
  isExpanded,
  onToggle,
}: {
  isExpanded: boolean;
  onToggle: (next: boolean) => void;
}) => {
  const handleClick = () => {
    mixpanelUtils.trackButtonClick(
      isExpanded ? "Collapse schedule" : "Expand schedule",
      MIXPANEL_SCREENS.DASHBOARD,
    );
    onToggle(!isExpanded);
  };

  const render = () => (
    <Button
      type="button"
      variant="ghost"
      onClick={handleClick}
      className="flex h-full w-6 shrink-0 flex-col items-center justify-start rounded-lg px-0 pt-3 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
    >
      <span className="flex h-8 w-full items-center justify-center">
        {isExpanded ? (
          <PanelLeftOpenIcon className="h-4 w-4" />
        ) : (
          <PanelRightOpenIcon className="h-4 w-4" />
        )}
      </span>
    </Button>
  );

  return render();
};
